const getProductsByIDQuery = /* GraphQL */ `
  query getProductByIDs($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        handle
        availableForSale
        title
        productType
        descriptionHtml
        featuredImage: images(first: 1) {
          edges {
            node {
              originalSrc
              altText
              width
              height
            }
          }
        }
      }
    }
  }
`

export default getProductsByIDQuery
